import { ApiError } from '../types/error'

// Note: This function is used in contexts where i18n may not be available
// The caller should handle i18n translation if needed
export function errorToMessage(error: unknown, defaultMessage?: string): string {
  if (error instanceof ApiError) {
    const source = error.error.source as Record<string, unknown> | undefined
    const title = source?.pointer || source?.header || source?.parameter
    if (title) {
      return `${title} : ${error.error.detail}`
    }
    else {
      return error.error.detail ?? defaultMessage ?? 'Unknown error'
    }
  }
  else if (error instanceof Error) {
    return error.message
  }
  return String(error || defaultMessage || 'Unknown error')
}
